export const BRACKET_KIND = {
  UNBOUNDED_LOW: 'unbounded-low',
  RANGE: 'range',
  UNBOUNDED_HIGH: 'unbounded-high'
};

export const CARBON_TAX_BRACKETS = [
  {
    kind: BRACKET_KIND.UNBOUNDED_LOW,
    upperExclusive: -20,
    base: 15,
    label: 'Below -20',
    narrative: '+$15M bonus'
  },
  {
    kind: BRACKET_KIND.RANGE,
    min: -20,
    max: -11,
    base: 10,
    label: '-20 to -11',
    narrative: '+$10M bonus'
  },
  {
    kind: BRACKET_KIND.RANGE,
    min: -10,
    max: -1,
    base: 5,
    label: '-10 to -1',
    narrative: '+$5M bonus'
  },
  {
    kind: BRACKET_KIND.RANGE,
    min: 0,
    max: 15,
    base: 0,
    label: '0 to 15',
    narrative: 'Neutral'
  },
  {
    kind: BRACKET_KIND.RANGE,
    min: 16,
    max: 30,
    base: -5,
    label: '16 to 30',
    narrative: '-$5M penalty'
  },
  {
    kind: BRACKET_KIND.RANGE,
    min: 31,
    max: 50,
    base: -10,
    label: '31 to 50',
    narrative: '-$10M penalty'
  },
  {
    kind: BRACKET_KIND.RANGE,
    min: 51,
    max: 75,
    base: -20,
    label: '51 to 75',
    narrative: '-$20M penalty'
  },
  {
    kind: BRACKET_KIND.RANGE,
    min: 76,
    max: 100,
    base: -25,
    label: '76 to 100',
    narrative: '-$25M penalty'
  },
  {
    kind: BRACKET_KIND.RANGE,
    min: 101,
    max: 130,
    base: -30,
    label: '101 to 130',
    narrative: '-$30M penalty'
  },
  {
    kind: BRACKET_KIND.RANGE,
    min: 131,
    max: 200,
    base: -40,
    label: '131 to 200',
    narrative: '-$40M penalty'
  },
  {
    kind: BRACKET_KIND.UNBOUNDED_HIGH,
    lowerExclusive: 200,
    base: -50,
    label: 'Over 200',
    narrative: '-$50M penalty'
  }
];
